// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"style_iframeWrapper__o4l-7","standard":"style_standard__gCThY","expanded":"style_expanded__qB9ri","useFullWidth":"style_useFullWidth__VqYUQ"};